import React from 'react';
// import PropTypes from 'prop-types';
import RepoItem from './RepoItem';
import { propTypes } from 'react-bootstrap/esm/Image';

export const Repos = ({ repos }) => {
  return repos.map((repo) => <RepoItem repo={repo} key={repo.id} />);
};
Repos.propTypes = {
  repos: propTypes.array,
};
